export enum TvConstants {
    GET_TV_SETTINGS = "GET_TV_SETTINGS",
};
  
  